import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade, Thumbs } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);

Fancybox.bind("[data-fancybox]", {});

const homeBannerSwiper = document.querySelector('#home-banner .banner-slider');
if (homeBannerSwiper) {
    const bannerSlider = new Swiper(homeBannerSwiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: homeBannerSwiper.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
}

const swiperCarousel = document.querySelectorAll('.swiper-carousel');
if (swiperCarousel.length) {
    swiperCarousel.forEach((carousel) => {
        let swiperEls = carousel.querySelectorAll('.swiper');
        swiperEls.forEach((swiperEl) => {
            let numSlides = swiperEl.querySelectorAll('.swiper-slide').length;
            let minSlides = parseInt(swiperEl.getAttribute('data-min-slides')) || 1;
            let maxSlides = parseInt(swiperEl.getAttribute('data-max-slides')) || 4;
            let autoPlay = swiperEl.getAttribute('data-autoplay') === 'true' ? true : false;
            let isLoop = false;
            if (numSlides > maxSlides) {
                isLoop = true
            }
            const swiper = new Swiper(swiperEl, {
                slidesPerView: minSlides,
                spaceBetween: 20,
                loop: isLoop,
                observer: true,
                observeParents: true,
                autoplay: autoPlay ? {
                    delay: 5000, // Delay of 5 seconds
                } : false,
                speed: 1000,
                pagination: {
                    el: swiperEl.closest('.swiper-carousel').querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperEl.closest('.swiper-carousel').querySelector('.swiper-button-next'),
                    prevEl: swiperEl.closest('.swiper-carousel').querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    480: {
                        slidesPerView: minSlides,
                    },
                    768: {
                        slidesPerView: Math.max(minSlides, maxSlides - 3),
                    },
                    1024: {
                        slidesPerView: Math.max(minSlides, maxSlides - 2),
                    },
                    1200: {
                        slidesPerView: Math.max(minSlides, maxSlides - 1),
                        spaceBetween: 30,
                    },
                    1400: {
                        slidesPerView: maxSlides,
                        spaceBetween: 30,
                    },
                },
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    // Step 1: Attach event listeners to tabs
    const tabs = document.querySelectorAll('.tabs-wrapper [role="tab"]');
    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            // Find parent .tabs-wrapper
            const tabsWrapper = tab.closest('.tabs-wrapper');
            // Assuming <li> is the direct parent of tab
            const clickedLi = tab.parentElement;
            const allLis = tabsWrapper.querySelectorAll('li');

            // Step 2: Toggle active class on <li> elements
            allLis.forEach(li => li.classList.remove('active'));
            clickedLi.classList.add('active');

            // Show/Hide corresponding tab panel
            const selectedPanelId = tab.getAttribute('aria-controls');
            const tabPanels = tabsWrapper.querySelectorAll('[role="tabpanel"]');
            tabPanels.forEach(panel => {
                if (panel.getAttribute('id') === selectedPanelId) {
                    panel.classList.remove('hidden', 'opacity-0');
                    panel.classList.add('active', 'opacity-100');
                } else {
                    panel.classList.remove('active', 'opacity-100');
                    panel.classList.add('hidden', 'opacity-0');
                }
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const filterSidebar = document.querySelector('.primary-sidebar');
    const closeBtn = '<a href="#" class="close-filter-sidebar absolute top-4 right-4 block md:!hidden">Đóng</a>';

    // Function to toggle back cover
    function toggleBackCover(show) {
        let backCover = document.querySelector('.back-cover');
        if (show) {
            if (!backCover) {
                backCover = document.createElement('div');
                backCover.className = 'back-cover fixed top-0 left-0 w-full h-full inset-0 bg-black/10 z-[500]';
                document.body.appendChild(backCover);
                // Add event to close filterSidebar when back cover is clicked
                backCover.addEventListener('click', function () {
                    filterSidebar.classList.remove('active');
                    toggleBackCover(false);
                });
            }
            backCover.style.display = 'block';
        } else if (backCover) {
            backCover.style.display = 'none';
        }
    }

    // Event delegation for toggle button
    document.body.addEventListener('click', function(e) {
        if (e.target.matches('.toggle-filter-btn')) {
            e.preventDefault();
            filterSidebar.classList.toggle('active');
            const isActive = filterSidebar.classList.contains('active');
            toggleBackCover(isActive);
        }
    });

    // Insert close button and setup event delegation for close button
    if (filterSidebar) {
        filterSidebar.insertAdjacentHTML('afterbegin', closeBtn);
        document.body.addEventListener('click', function(e) {
            if (e.target.matches('.close-filter-sidebar')) {
                e.preventDefault();
                filterSidebar.classList.remove('active');
                toggleBackCover(false);
            }
        });
    }
});

jQuery(document).ready(function ($) {
    const pricePlaceholder = $('.summary .price');
    $('.variations_form').on('show_variation', function (event, variation) {
        if (variation.price_html) {
            let discountMarkup = '';
            if (variation.display_regular_price > variation.display_price) {
                const discountPercentage = Math.round(((variation.display_regular_price - variation.display_price) / variation.display_regular_price) * 100);
                discountMarkup = '<span class="sale-percentage">' + discountPercentage + '% giảm</span>';
            }
            pricePlaceholder.html(variation.price_html + discountMarkup);
        }
    });
    $('body').on('click', '.buy_now_button', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form.cart');
        $('.is_buy_now', $form).val('1'); // Set the hidden input to indicate a "buy now" action
        $('button.single_add_to_cart_button', $form).click(); // Programmatically click the add to cart button
    });

    $(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
        let $form = $button.closest('form.cart');
        if ($('.is_buy_now', $form).val() === '1') {
            window.location.href = wc_add_to_cart_params.cart_url; // Redirect to checkout if "buy now" was used
        }
    });
});

jQuery(function ($) {
    let timeout;

    // Function to update the cart
    function updateCart() {
        $('[name="update_cart"]').trigger('click');
    }

    // Listen for quantity changes with debouncing
    $(document).on('change', 'input.qty', function () {
        clearTimeout(timeout);
        timeout = setTimeout(updateCart, 300); // Adjust the timeout as needed
    });
});

document.addEventListener('click', function (e) {
    const item = e.target.closest('.accordion-item');
    if (!item) return;
    const accordionWrapper = item.closest('.accordion-wrapper');
    const activeItem = accordionWrapper.querySelector('.active');
    if (activeItem && activeItem !== item) {
        activeItem.classList.remove('active');
    }
    item.classList.toggle('active');
});